export default [
  {
    variant: "welcome",
    subtitle: "FREE SIGN UP BONUS",
    title: "FREE DAILY REWARDS",
    description: "Spin the wheel from the Daily Login Calendar",
    buttonText: "Claim Now",
    link: "/offers",
    // Reuses the AnonymousHero's background so the welcome card and the
    // hero read as one consistent visual moment for new visitors.
    image: "/hero-background2.png",
  },
  {
    id: "first_purchase",
    variant: "default",
    subtitle: "1st Purchase Bonus",
    title: "1ST PURCHASE BONUS",
    description: "Get bonus coins on your first purchase",
    buttonText: "Buy Now",
    link: "/offers",
    // %25 is the URL-encoded form of the literal '%' in the file name
    // "50%-bonus.png". Note: this is only the fallback image — buildPromoCards
    // overrides it with each backend offer's image_url when offers exist.
    image: "/50%25-bonus.png",
  },

  {
    id: "refer_friend",
    variant: "default",
    subtitle: "INVITE FRIENDS",
    title: "REFER A FRIEND",
    description: "10CB when your friend makes their first purchase",
    buttonText: "Invite Now",
    link: "/refer",
    image: "/refer.png",
  },

  {
    id: "huge_collection",
    variant: "default",
    title: "HUGE GAME COLLECTION",
    description: "New games added daily",
    image: "/games.png",
    buttonText: "Play Now",
    link: "/games/slots",
  },

  {
    variant: "daily",
    subtitle: "VIP BONUSES",
    title: "FREE DAILY REWARDS",
    description: "Claim daily rewards based on your VIP level",
    buttonText: "Collect Daily",
    link: "/offers",
    image: "/vip.png",
  },

  {
    variant: "daily",
    subtitle: "WEEKLY OFFERS",
    title: "WEEKLY RELOAD",
    description: "Get extra coins with your weekly purchases",
    buttonText: "Learn More",
    link: "/offers",
    image: "/reload.png",
  },
];
